import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Courses from "../pages/courses/page";
import Software from "../pages/software/page";
import DaaS from "../pages/daas/page";
import Alert from "../pages/alert/page";
import Events from "../pages/events/page";
import Contact from "../pages/contact/page";
import Partnerships from "../pages/partnerships/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/software",
    element: <Software />,
  },
  {
    path: "/daas",
    element: <DaaS />,
  },
  {
    path: "/alert",
    element: <Alert />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/partnerships",
    element: <Partnerships />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
